import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

export const loginGuard: CanActivateFn = (route, state) => {
  const msalService = inject(MsalService);
  const router = inject(Router);

  // Check if user has an active account (token)
  const account = msalService.instance.getActiveAccount();

  if (account) {
    // If token exists, redirect to dashboard
    router.navigate(['/dashboard']);
    return false;
  }

  // No token exists, allow access to login page
  return true;
};
